import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-refetch'
import { Button, Card, CardTitle, CardText, CardActions, Switch } from 'react-mdl'
import * as styles from '../styles/styles'
import { connectDefault, checkNextPropsPromiseFulfilled } from '../utils/utils'
import * as actions from '../actions/index'
import { InfoPanel } from '../containers/InfoPanel'

import config from '../utils/config'

var introJs = require("intro.js").introJs();
var willShowIntro = false

const roleToLabels = {
  u: {
    title: "Channels",
    create: "Add channel",
    dataIntro: 'How do you want your customers to contact you? Go here to select.'
  },
  a: {
    title: "Integrations",
    create: "Add integration",
    dataIntro: 'What does your business use for customer support? Go here to setup.'
  },
  p: {
    title: "Providers",
    create: "Add provider"
  }
};

const roleToNoItemsInfoPanel = {
  u: {
    title: 'How will your customers contact you?',
    text: 'You can add Web Chat, SMS, Facebook Messenger, and other major messaging apps'
  },
  a: {
    title: 'What system does your customer success team use?',
    text: 'Integrate AssistHub with your CRM or contact center software. All customer conversations can be handled within your customer service system.'
  },
  p: {
    title: '',
    text: ''
  }
};


export class Channels extends Component {

  static propTypes = {
    location: PropTypes.object.isRequired,
    ahBaseUrl: PropTypes.string.isRequired,
    appJWT: PropTypes.string.isRequired,
    channelTypes: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props,context) {
    super(props,context);

    this.state = {channels:[]}

    this.createChannel = this.createChannel.bind(this);
    this.viewChannel = this.viewChannel.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  handleCheckboxChange(channel) {
    channel.enabled = !channel.enabled;
    this.props.putChannel(channel)
  }

  componentWillMount() {
    this.props.fetchChannels()
  }

  componentWillReceiveProps(nextProps) {
    if (checkNextPropsPromiseFulfilled(this.props, nextProps, 'channels')) {
      const channels = nextProps.channels.value;
      const channelsTitles = {}
      for (var x = 0 ; x<channels.length ; x++) {
        const channel = channels[x]
        channelsTitles[channel.id] = this.headerForChannel(channel)
      }
      // Add Channel Type names to the breadcrump titles,
      // since channel creation happens in this component
      const types = this.props.channelTypes;
      for (var y = 0 ; y<types.length ; y++) {
        const t = types[y]
        channelsTitles[t.id] = t.name;
      }

      this.props.dispatch(actions.addBreadcrumbsRouteTitles({'channel': channelsTitles}));

      //clone nextProps.channels to this.state.channels
      let newChannels = []
      for (var i = 0; i < channels.length; i++) {
        const channel = channels[i]
        let newChannel = {};
        for (var key in channel) {
          if (channel.hasOwnProperty(key)) {
            if (channel[key] instanceof Object) {
              newChannel[key] = {...channel[key]}
            }
            else {
              newChannel[key] = channel[key]
            }
          }
        }
        newChannels.push(newChannel)
      }
      this.setState({channels:newChannels})

      if (!sessionStorage.getItem('introjs_AppChannel') && channels.length === 0) {
        willShowIntro = true
        sessionStorage.setItem('introjs_AppChannel', true)
      }
    }
  }

  componentDidUpdate() {
    if (willShowIntro && !this.props.children) {
      introJs.start()

      willShowIntro = false
    }
  }

  createChannel(role) {
    introJs.exit()
    const pathComponents = this.props.location.pathname.split("/");
    pathComponents.splice(pathComponents.length-1, 1);
    const path = pathComponents.join("/")
    this.context.router.push(`${path}/channeltypes/${role}`);
  }

  viewChannel(channel) {
    const {channelTypes, location} = this.props
    if (channelTypes !== undefined) {
      const pathComponents = location.pathname.split("/");
      pathComponents.splice(pathComponents.length-1, 1);
      const path = pathComponents.join("/")
      this.context.router.push(`${path}/channels/${channel.id}`);
    }
  }

  headerForChannel(channel) {
    return channel.title ? channel.title : this.getChannelTypeName(channel)
  }

  getChannelTypeName(channel) {
    const channelType = channel.id

    const { channelTypes } = this.props

    for (var i = 0 ; i<channelTypes.length ; i++) {
      let channelConfig = channelTypes[i]
      if (channelType === channelConfig.id) {
        return channelConfig.name
      }
    }

    return ''
  }

  renderChannelBox(channel, index) {
    return (
      <div key={index} style={styles.appChannels.cardDiv}>
        <Card shadow={0} style={styles.appChannels.card}>
          <CardTitle style={styles.appChannels.cardTitle}>
            {this.headerForChannel(channel)}<br />
          </CardTitle>
          <CardText style={styles.appChannels.cardText}>
            Type: {this.getChannelTypeName(channel)}<br/>
            <br/>
          </CardText>
          <CardActions border style={styles.appChannels.cardActions}>
            <Button onClick={()=>{this.viewChannel(channel)}}>Edit</Button>
            <div className="mdl-layout-spacer"></div>
            <div style={{width: '48px'}}>
              <Switch id={channel.id + '_enabled'} checked={channel.enabled} onChange={()=>this.handleCheckboxChange(channel)}></Switch>
            </div>
          </CardActions>
        </Card>
      </div>
    )
  }

  renderChannels(role) {
    const { channels } = this.state
    const { channelTypes } = this.props

    const channelsByRole = channels.filter((channel) => channel.id.startsWith(role))
    const channelTypesByRole = channelTypes.filter((channel) => channel.id.startsWith(role))

    if (channelTypesByRole.length === 0) {
      return <div></div>
    }

    const labels = roleToLabels[role];

    const noItemsInfoPanel = roleToNoItemsInfoPanel[role];

    return (
      <div>
        <h4>{labels.title}
          <Button raised colored onClick={()=>this.createChannel(role)} style={styles.button.add} {...labels.dataIntro ? {'data-intro':labels.dataIntro} : {}}>
            {labels.create}
          </Button>
        </h4>
        {
          // We show the InfoPanel if the props.channels has already been fetched.
          this.props.channels !== undefined && this.props.channels.fulfilled && channelsByRole.length === 0
              ? <InfoPanel title={noItemsInfoPanel.title} text={noItemsInfoPanel.text}/>
              : channelsByRole.map(this.renderChannelBox.bind(this))
        }
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.renderChannels('u')}
        {this.renderChannels('a')}
        {config.ENV === 'prod' ? <div></div> : this.renderChannels('p') }
      </div>
    )
  }

}

export default connect.defaults(connectDefault)(props => {
  return {
    fetchChannels: () => ({
      channels: {
        title: 'Fetch Channels',
        dispatch: props.dispatch,
        appJWT: props.appJWT,
        url:`${props.ahBaseUrl}/channels`,
        refreshing: true, force: true,
      },
    }),
    putChannel: channel => ({
      putChannelResponse: {
        title: 'Update Channel',
        dispatch: props.dispatch,
        appJWT: props.appJWT,
        url: `${props.ahBaseUrl}/channels/${channel.id}`,
        refreshing: true, force: true,
        method: 'PUT',
        body: channel
      }
    }),
  }
})(Channels)



// WEBPACK FOOTER //
// ./src/components/AppChannels.js